<template>
  <div class="wrap">
    <div class="title">
      <div class="title_left">评价管理</div>
    </div>
    <div class="innerBox">
      <div class="filtrate">
        <el-select
          @change="optionChange"
          class="mr10"
          v-model="value"
          placeholder="综合评分筛选"
          clearable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="mr10">评价时间:</span>
        <el-date-picker
          @change="handleDateClick"
          class="w140 mr10"
          type="date"
          value-format="yyyy-MM-dd"
          v-model="queryLimit.startDate"
          placeholder="选择起始日期"
          :picker-options="beforeDate"
          clearable
        ></el-date-picker>至
        <el-date-picker
          @change="handleDateClick"
          v-model="queryLimit.endDate"
          value-format="yyyy-MM-dd"
          class="w140 ml10 mr20"
          type="date"
          placeholder="选择截止日期"
          :picker-options="afterDate"
          clearable
        ></el-date-picker>
        <el-checkbox
          v-model="queryLimit.hasFile"
          @change="refresh"
          style="line-height:34px;"
        >有图片附件</el-checkbox>
        <el-checkbox
          v-model="queryLimit.hasContent"
          @change="refresh"
          style="line-height:34px;"
        >有文字评价</el-checkbox>
        <el-checkbox v-model="queryLimit.hasTag" @change="refresh" style="line-height:34px;">有快捷评价</el-checkbox>
        <el-button class="ml10" @click="reset">重置</el-button>
        <el-button type="primary" class="fr" @click="delTips">批量删除</el-button>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="tabOffTop120">
          <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
          <el-table
            ref="multipleTable"
            :data="tableData.records"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            @sort-change="sortChange"
            v-loading = "loading"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="username" label="用户名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="averageStar" label="综合评分" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tasteStar" label="菜品味道"></el-table-column>
            <el-table-column prop="milieuStar" label="就餐环境"></el-table-column>
            <el-table-column prop="healthStar" label="卫生情况"></el-table-column>
            <el-table-column prop="tags" label="快捷评价"></el-table-column>
            <el-table-column prop="content" width="200" label="文字评价" show-overflow-tooltip></el-table-column>
            <el-table-column label="图片" min-width="150">
              <template slot-scope="scope" v-if="scope.row.files.length>0">
                <a href="javascript:;" class="operate-a" @click="previewImg(scope.row.files)">图片附件({{scope.row.files.length}})</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              width="200"
              label="评价时间"
              show-overflow-tooltip
              sortable="custom"
            ></el-table-column>
            <el-table-column label="操作" min-width="150">
              <template slot-scope="scope">
                <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row.id)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box"> 
          <el-pagination
            background
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="queryLimit.current"
            :page-sizes="[10, 20, 30, 40,50]"
            :page-size="queryLimit.size"
            layout="total,prev, pager, next, sizes, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
       <Preview :showImg="show" @close="show = false" :imgList="fileList"></Preview>
    </div>
  </div>
</template>
<script>
import * as api from "api/com";
import Preview from 'components/previewImg';
export default {
   components: {Preview},
  data() {
    return {
      baseUrl: this.$store.state.common.baseUrl,
      options: [
        {
          lable: "1分-2分",
          value: "1-2"
        },
        {
          lable: "2分-3分",
          value: "2-3" 
        },
        {
          lable: "3分-4分",
          value: "3-4"
        },
        {
          lable: "4分-5分",
          value: "4-5"
        }
      ],
      value: "",
      queryLimit: {
        startDate: "",
        endDate: "",
        hasFile: false,
        hasTag: false,
        hasContent: false,
        current: 1,
        size: 10,
        assessmentDateOrder: "",
        averageStarMin: "",
        averageStarMax: ""
      },
      afterDate: {
        disabledDate: time => {
          let startDate = new Date(this.queryLimit.startDate);
          if (this.queryLimit.startDate) {
            return time.getTime() < startDate - 8.64e7;
          }
        }
      },
      beforeDate: {
        disabledDate: time => {
          let endDate = new Date(this.queryLimit.endDate);
          if (this.queryLimit.endDate) {
            return time.getTime() > endDate;
          }
        }
      },
      tableData: {},
      multipleSelection: [],
      show:false,
      fileList:[],
      loading:false
    };
  },
  methods: {
    refresh(){
      this.queryLimit.current = 1;
      this.tableData = {};
      this.searchTab();
    },
    async searchTab() {
      this.loading = true;
      let result = await api.getAssessment(this.queryLimit);
      this.tableData = result.data;
      this.tableData.records.map(item => {
        item.tags = [...item.goodTags,...item.badTags]; 
        if (item.tags.length > 0) {
          item.tags = item.tags.join(",");
        }
      }); 
      this.loading = false;
    },
    pageCurrentChange(num) {
      this.queryLimit.current = num;
      this.searchTab();
    },
    pageSizeChange(size) {
      this.queryLimit.size = size;
      this.searchTab();
    },
    handleDateClick() {
      if (
        (this.queryLimit.startDate && this.queryLimit.endDate) ||
        (this.queryLimit.startDate === null && this.queryLimit.endDate === null)
      ) {
        this.refresh();
      }
    },
    sortChange(column) {
      if (column.order == "ascending") {
        if (column.prop == "createTime") {
          this.queryLimit.assessmentDateOrder = "ASC";
        }
      }
      if (column.order == "descending") {
        if (column.prop == "createTime") {
          this.queryLimit.assessmentDateOrder = "DESC";
        }
      }
      if (column.order === null) {
        if (column.prop == "createTime") {
          this.queryLimit.assessmentDateOrder = "";
        }
      }
      this.searchTab();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    optionChange(val) {
      this.queryLimit.averageStarMin = val.substring(0, 1);
      this.queryLimit.averageStarMax = val.substring(2);
      this.refresh();
    },
    reset() {
      this.value = '';
      this.queryLimit.averageStarMin = "";
      this.queryLimit.averageStarMax = "";
      this.queryLimit.startDate = "";
      this.queryLimit.endDate = "";
      this.queryLimit.hasFile = false;
      this.queryLimit.hasTag = false;
      this.queryLimit.hasContent = false;
      this.searchTab();
    },
    async delTips() {
      if (!this.multipleSelection.length > 0) {
        this.$message({
          message: "勾选需要删除的数据后才能批量删除哦",
          type: "warning"
        });
      } else if (this.multipleSelection.length > 0) {
        try {
          await this.$confirm("是否确认删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
          let result = [];
          this.multipleSelection.map(item => {
            result.push(item.id);
          });
          this.batchDel(result);
        } catch (e) {}
      }
    },
    async delConfirm(data) {
      try {
        await this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        let result = [];
        result.push(data);
        await this.batchDel(result);
      } catch (e) {}
    },
    async batchDel(data) {
      let result = await api.delAssessment(data);
      if (result.code == 200) {
        this.$message.success("删除成功!");
        this.searchTab();
      }
    },
    previewImg(imgList){
      this.fileList = []
      imgList.map(item =>{
        this.fileList.push(this.baseUrl+'/'+item.fileUrl) 
      })
      this.show = true
    }
  },
  mounted() {
    this.searchTab();
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  width: calc(100% - 40px);
  padding: 0 20px;
  height: 100%;
  background: #f6f6f6;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
    }
  }
  .innerBox {
    width: calc(100% - 60px);
    padding: 20px 30px;
    height: calc(100% - 125px);
    background: #fff;
    border-radius: 10px;
    overflow: scroll;
    .filtrate {
      vertical-align: center;
      .year {
        font-size: 12px;
        line-height: 18px;
        color: #666666;
      }
    }
    .operate {
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
